import React from "react";
import { useNavigate } from "@remix-run/react";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const onClickGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen px-4">
      <img
        src={"/images/errors/not-found-page.png"}
        alt="Page Not Found"
        className="w-full h-auto max-w-80"
        width={320}
        height={320}
      />
      <h1 className="text-2xl font-bold text-primary mt-8">
        Oh snap! Something is missing.
      </h1>
      <p className="text-lg mt-4 max-w-md text-center">
        Sorry, unfortunately the page you're looking for isn't there or does not
        exist on our website.
      </p>
      <button
        className="mt-8 inline-block px-6 py-3 bg-primary rounded-md hover:bg-[#4c3dff] transition-colors"
        onClick={onClickGoBack}
      >
        <p className="text-md text-white font-bold">Go Back</p>
      </button>
    </div>
  );
};

export default NotFoundPage;
